import type { GtmEventPayload } from './types';
import { getPageSectionFromPath } from './getPageSection';

declare global {
  interface Window {
    portalUser?: { clientId?: string };
    portalContext?: { addressId?: string };
    dataLayer?: Record<string, unknown>[];
  }
}

function resolveClientId(): string {
  const w = window.portalUser?.clientId;
  if (w) return String(w);
  return '';
}

function resolveAddressId(): string {
  const w = window.portalContext?.addressId;
  if (w) return String(w);
  return '';
}

function resolveAnalyticsID(): string {
  const c = resolveClientId();
  const a = resolveAddressId();
  if (!c && !a) return '';
  return `${c}|${a}`;
}

/**
 * Push único para o dataLayer (GTM). Usar em todo o portal no lugar de TagManager.initialize.
 */
export function pushGtmEvent(
  partial: Partial<GtmEventPayload> & Pick<GtmEventPayload, 'event'>
): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  const client_id = partial.client_id ?? resolveClientId();
  const address_id = partial.address_id ?? resolveAddressId();
  const analyticsID =
    partial.analyticsID ??
    (client_id || address_id ? resolveAnalyticsID() : '');

  const pageSection =
    partial.pageSection ?? getPageSectionFromPath(window.location.pathname);

  const payload: Record<string, unknown> = {
    ...partial,
    client_id,
    address_id,
    analyticsID,
    pageSection,
  };

  Object.keys(payload).forEach((key) => {
    if (payload[key] === '' || payload[key] === undefined) {
      delete payload[key];
    }
  });

  window.dataLayer.push(payload as GtmEventPayload & Record<string, unknown>);
}
